module.exports = __webpack_public_path__ + "static/media/loveblossom.2a22cd9f.jpg";